import { withRouter } from 'react-router-dom'
import DelayLink from './DelayLink'

export default withRouter(DelayLink)
